const ZIP_MIME_TYPES = new Set([
  'application/zip',
  'application/x-zip-compressed',
  'application/x-zip',
  'application/x-rar-compressed',
  'application/vnd.rar',
  'application/x-7z-compressed',
  'application/x-tar',
  'application/gzip',
  'application/x-gzip',
]);

// Classifies an uploaded file/attachment's MIME type into the shapes the
// message UI knows how to render — image previews, inline video/audio
// players, a distinct archive icon for zip/rar/7z/tar, and a generic
// file/document row for everything else (PDFs, docs, ...).
/**
 * Classifies a MIME type into a UI-friendly attachment category.
 *
 * @param {string} mimeType - The MIME type of the attachment
 * @returns {'image'|'video'|'audio'|'zip'|'file'} The attachment category
 */
export function classifyAttachmentType(mimeType) {
  if (mimeType?.startsWith('image/')) return 'image';
  if (mimeType?.startsWith('video/')) return 'video';
  if (mimeType?.startsWith('audio/')) return 'audio';
  if (mimeType && ZIP_MIME_TYPES.has(mimeType)) return 'zip';
  return 'file';
}
